import { useContext } from "react";
import { LocaleContext } from "../app";
import { Link } from "react-router";

export function NextStatements({ content }) {
  const { translate } = useContext(LocaleContext);

  return (
    <>
      {content.settings.availableStatements.map((key) => (
        <Link to={`../${key}`} key={key} className="link-card">
          {translate(["statements", key, "shortName"])}
        </Link>
      ))}
    </>
  );
}
